<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import AppFooter from "./components/AppFooter.vue";
import AppHeader from "./components/AppHeader.vue";
import BackgroundShapes from "./components/BackgroundShapes.vue";
import PickupCartBar from "./components/PickupCartBar.vue";

const route = useRoute();
const shouldShowChrome = computed(() => route.meta.hideChrome !== true);
const shouldShowCartBar = computed(() =>
  route.name !== "products-pickup-time" &&
  route.name !== "products-confirmation",
);
</script>

<template>
  <div class="relative text-app-text antialiased">
    <BackgroundShapes />

    <div class="flex min-h-screen flex-col">
      <AppHeader v-if="shouldShowChrome" />

      <main class="flex flex-1 flex-col">
        <router-view v-slot="{ Component, route: childRoute }">
          <Transition v-if="childRoute.meta.hideChrome !== true"
            enter-active-class="transition-all duration-200 ease-out" enter-from-class="translate-y-2 opacity-0"
            leave-active-class="transition-all duration-150 ease-in" leave-to-class="-translate-y-2 opacity-0"
            mode="out-in">
            <component :is="Component" />
          </Transition>
          <component v-else :is="Component" />
        </router-view>
      </main>
    </div>

    <AppFooter v-if="shouldShowChrome" />

    <PickupCartBar v-if="shouldShowCartBar" />
  </div>
</template>
